import { PendencyType } from 'domain/entities/surgical-pendency'

export const typedPendenciesContent = {
  [PendencyType.AUTHORIZATION]: 'de Autorização',
  [PendencyType.ASSISTANCE]: 'Assistenciais'
}
